import type { SortFieldOption } from 'core/components/server-side-pagination/ServerSideSort'
import type { VMFilterParams } from './useVMFilterConfigs'

export const defaultVMFilterParams: VMFilterParams = {
  cluster: 'all',
  vm_state: 'all',
  owner: 'all',
  flavor: 'all',
  image: 'all',
  host: 'all',
  tenant_id: '',
}

export enum IVirtualMachinesListPageTabs {
  VirtualMachinesList = 'list',
  ResourceUtilization = 'resource-utilization',
}

export enum VM_SEARCH_FIELDS_ENUM {
  NAME = 'name',
  UUID = 'uuid',
  IP = 'ip',
  IP6 = 'ip6',
  METADATA = 'metadata',
}

// Search field options for VMs
export const VM_SEARCH_FIELDS = [
  { value: VM_SEARCH_FIELDS_ENUM.NAME, label: 'Name' },
  { value: VM_SEARCH_FIELDS_ENUM.UUID, label: 'UUID' },
  { value: VM_SEARCH_FIELDS_ENUM.IP, label: 'IPv4 Address' },
  { value: VM_SEARCH_FIELDS_ENUM.IP6, label: 'IPv6 Address' },
  { value: VM_SEARCH_FIELDS_ENUM.METADATA, label: 'Metadata' },
]

// Sort field options for VMs
export const VM_SORT_OPTIONS: SortFieldOption[] = [
  { value: 'created_at', label: 'Created At' },
  { value: 'display_name', label: 'Name' },
  { value: 'uuid', label: 'UUID' },
  { value: 'vm_state', label: 'State' },
  { value: 'cluster', label: 'Cluster' },
  { value: 'owner', label: 'Owner' },
  { value: 'host', label: 'Host' },
  { value: 'instance_type_id', label: 'Flavor' },
  { value: 'tenant_id', label: 'Tenant' },
  { value: 'image_ref', label: 'Source Image' },
  { value: 'updated_at', label: 'Updated At' },
  { value: 'launched_at', label: 'Launched At' },
  { value: 'terminated_at', label: 'Terminated At' },
]

// Grid column key → Nova API sort key
export const VM_COLUMN_TO_SORT_KEY: Record<string, string> = {
  name: 'display_name',
  id: 'uuid',
  state: 'vm_state',
  ownerName: 'owner',
  clusterName: 'cluster',
  tenantName: 'tenant_id',
  flavorName: 'instance_type_id',
  imageName: 'image_ref',
  created: 'created_at',
  updated: 'updated_at',
  launched_at: 'launched_at',
  terminated_at: 'terminated_at',
  'OS-EXT-SRV-ATTR:hypervisor_hostname': 'host',
}

// Nova API sort key → Grid column key (reverse of above)
export const VM_SORT_KEY_TO_COLUMN: Record<string, string> = Object.fromEntries(
  Object.entries(VM_COLUMN_TO_SORT_KEY).map(([col, api]) => [api, col]),
)

// Valid VM states for the Change Tenant action
export const CHANGE_TENANT_VALID_STATES = ['active', 'stopped', 'paused', 'suspended']
